export const PrimaryNavigation = {
  SEGMENT: 'SEGMENT',
  CONTENT: 'CONTENT',
  CAMPAIGN: 'CAMPAIGN',
  JOURNEY: 'JOURNEY',
  ADMIN: 'ADMIN',
};
